import { PasswordValidationRule } from '../password-validation';

/**
 * Default password validation rules
 * Based on design requirements:
 * - At least 1 letter
 * - At least 1 number
 * - Between 8 and 20 characters
 *
 * Dictionary keys can be used for i18n support. If dictionaryKey is provided,
 * it will be resolved using usePasswordRulesWithDictionary() hook.
 * The label serves as a fallback if dictionaryKey is not found.
 */
export const passwordRules: PasswordValidationRule[] = [
  {
    id: 'hasLetter',
    label: 'contain at least 1 letter',
    dictionaryKey: 'Components.MyAccount.ContainsOneLetter',
    test: (password: string) => /[a-zA-Z]/.test(password),
  },
  {
    id: 'hasNumber',
    label: 'contain at least 1 number',
    dictionaryKey: 'Components.MyAccount.ContainsOneNumber',
    test: (password: string) => /[0-9]/.test(password),
  },
  {
    id: 'length',
    label: 'be between 8 and 20 characters',
    dictionaryKey: 'Components.MyAccount.BetweenEightAndTwenty',
    test: (password: string) => password.length >= 8 && password.length <= 20,
  },
];
